(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["as-seen-on-video-slider"] && !Shopify.designMode) return;
  try {
    
var swiper = new Swiper('.aso-swiper', {
  slidesPerView: 3,
  spaceBetween: 20,
  loop: true,
  centeredSlides: false,
  breakpoints: {
    320: { slidesPerView: 1.2 },
    768: { slidesPerView: 2.2 },
    1200: { slidesPerView: 4 }
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  }
});

  } catch(e) { console.error(e); }
})();
})();
